export default __webpack_public_path__ + "static/media/wedding-3.c11bdf4e.jpg";